module.exports = __webpack_public_path__ + "img/1x.e938105.jpg";